import { FeatureName } from '@/context/FeatureToggleContext/FeatureToggleContext';

export interface Entry {
  id: string;
  label: string;
  basePath?: string | string[];
  items?: Entry[];
  featureFlag?: FeatureName;
  disabled?: boolean;
  comingSoon?: boolean;
}

export interface NavigationSettings {
  entries: {
    [id: string]: Entry;
  };
  order: string[];
}

export interface NavbarEntry extends Entry {
  route: string;
}

export interface BackNavigationState {
  from: string;
}

export const isBackNavigationState = (state: unknown): state is BackNavigationState => {
  if (typeof state !== 'object' || state === null || !('from' in state)) {
    return false;
  }

  return typeof state.from === 'string';
};
